<template>
  <div>
    <b-form @submit="onSubmit">
      <b-form-group :label="$t('share.content.youtube_form_title')">
        <b-form-input v-model="form.title" required></b-form-input>
      </b-form-group>
      <b-form-group :label="$t('share.content.youtube_form_description')">
        <b-form-textarea v-model="form.description"
                         rows=3
                         required>
        </b-form-textarea>
      </b-form-group>
      <b-form-group :label="$t('share.content.youtube_form_category')">
        <b-form-select v-model="form.category"
                       :options="categoryOptions"
                       required>
        </b-form-select> 
      </b-form-group>
      <b-form-group :label="$t('share.content.youtube_form_privacy')">
        <b-form-select v-model="form.privacy"
                       :options="privacyOptions"
                       required>
        </b-form-select>
      </b-form-group>
      <div class="icon-panel">
        <b-col class="text-right">
          <b-button type="submit" variant="primary">{{ $t("share.content.youtube_form_submit_btn") }}</b-button>
        </b-col>
      </div>
    </b-form>
  </div>
  
</template>

<script>
export default {
  name: 'Youtube',
  data() {
    return {
      categoryOptions: {
        '1': 'Film & Animation',
        '2': 'Autos & Vehicles',
        '10': 'Music',
        '15': 'Pets & Animals',
        '17': 'Sports',
        '19': 'Travel & Events',
        '20': 'Gaming',
        '22': 'People & Blogs',
        '23': 'Comedy',
        '24': 'Entertainment',
        '25': 'News & Politics',
        '26': 'Howto & Style',
        '27': 'Education',
        '28': 'Science & Technology',
        '29': 'Nonprofits & Activism'
      },
      privacyOptions: {
        "public": "Public",
        "unlisted": "Unlisted",
        "private": "Private",
        "scheduled": "Scheduled"
      },
      form: {
        title: '',
        description: '',
        category: '',
        privacy: ''
      }
    }
  },
  methods: {
    onSubmit() {
      event.preventDefault()
      this.$emit('submit', this.form)
    }
  },
  created() {
    this.$emit("loaded")
  }
}
</script>
